import React from "react";
import { TableRow } from "@mui/material";
import { ParentProps } from "../../types";
import "./styles.scss";

const classNameBase = "scd-table-light-row";

export default function RowTableLight(props: ParentProps): React.JSX.Element {
  const { children } = props;

  return (
    <TableRow
      tabIndex={-1}
      classes={{
        root: `${classNameBase}-root`,
        selected: `${classNameBase}-selected`,
        hover: `${classNameBase}-hover`,
        head: `${classNameBase}-head`,
        footer: `${classNameBase}-footer`,
      }}
    >
      {children}
    </TableRow>
  );
}
